<main>
  <header>
    <div class="search-bar">
      <div class="position-relative flex-grow-1">
        <input type="text" class="form-control" placeholder="Search"
               [(ngModel)]="keyword" (ngModelChange)="filterMatchingOrders()">
        <i class="fa-solid fa-magnifying-glass"></i>
      </div>
    </div>
  </header>

  <oaibox-operations-kanban-board [orders]="shownOrders"></oaibox-operations-kanban-board>
</main>
